import { User } from '../models/user.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

import checkLoginMutation from 'src/app/graphql/mutations/check_login.mutation.graphql'
import loginMutation from 'src/app/graphql/mutations/do_login.mutation.graphql'
import logoutMutation from 'src/app/graphql/mutations/do_logout.mutation.graphql'

@Injectable()
export class LoginService extends GraphQLService<User> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  checkEmail(user: User): Observable<User> {
    return this.push(`checkEmail(username: "${ user.username }") { requireLogin }`)
  }

  doLogin(user: User, iso: string): Observable<User> {
    return this.push(loginMutation, {username: user.username, password: user.password, iso})
  }

  doLogout(persistenceToken: string): Observable<User> {
    return this.push(logoutMutation, {persistenceToken})
  }

  checkLogin(persistenceToken: string): Observable<User> {
    return this.push(checkLoginMutation, {persistenceToken})
  }

  private userFragment(): string {
    return ``
  }

}
